module.exports = __webpack_public_path__ + "img/dc_02.cdc2690e.jpg";